<template>
  <div class="page-main">
    <div class="details box">
      <h3>资金信息</h3>
      <ul>
        <li>
          <p class="name">
            <Icon type="ios-cash" />账号余额(可提现)
          </p>
          <!-- <p class="number">￥{{ accountMsg.accountBalance }}</p> -->
          <p class="number">￥{{ accountMsg.canWithdrawal }}</p>
        </li>
        <li>
          <p class="name">
            <Icon type="ios-cash" />
            <span>待提现</span>
          </p>
          <p class="number">￥{{ accountMsg.pendWithdrawal }}</p>
        </li>
        <li>
          <p class="name">
            <Icon type="ios-cash" />
            <span>已提现</span>
          </p>
          <p class="number">￥{{ accountMsg.cashWithdrawal }}</p>
        </li>
      </ul>
    </div>
    <Card title="提现申请" class="app-list">
      <div class="content">
        <Row>
          <Col span="12">
            <Form
              autocomplete="off"
              class="form"
              hide-required-mark
              label-position="left"
              :label-width="100"
            >
              <FormItem label="开户公司">
                <span>{{ data.bank_company }}</span>
              </FormItem>
              <FormItem label="开户银行">
                <span>{{ data.bank_bankname }}</span>
              </FormItem>
              <FormItem label="支行名称">
                <span>{{ data.bank_branchname }}</span>
              </FormItem>
              <FormItem label="开户地址">
                <span>{{ data.bank_address }}</span>
              </FormItem>
              <FormItem label="银行账号">
                <span>{{ data.bank_account }}</span>
              </FormItem>
              <FormItem label="开户许可证">
                <img
                  class="bankImg"
                  @click="showBigImg(title,data.bank_permit_img)"
                  :src="data.bank_permit_img"
                  alt="开户许可证"
                />
              </FormItem>
            </Form>
          </Col>
          <Col span="12">
            <Form
              autocomplete="off"
              class="form"
              hide-required-mark
              label-position="left"
              ref="form"
              :rules="rule"
              :model="form"
              :label-width="80"
            >
              <FormItem label="提现金额" prop="withdrawal">
                <InputNumber style="width: 120px" :min="0" :step="100" v-model="form.withdrawal"></InputNumber>
                <Button type="text" @click="allWithdrawal('form')">全部提现</Button>
              </FormItem>
              <FormItem>
                <Button type="primary" @click="handleSubmit('form')">提交</Button>
              </FormItem>
            </Form>
          </Col>
        </Row>
      </div>
    </Card>
  </div>
</template>

<script>
import { financeInfo, applyCashout } from "@/service/api.js";

export default {
  data() {
    const validateWithdrawal = (rule, value, callback) => {
      console.log(value);
      if (value < 1) {
        callback(new Error("提现金额最少为1"));
      } else {
        if (this.accountMsg.canWithdrawal < value) {
          // 对余额做判断
          callback(new Error("当前申请提现金额超出可提现范围"));
        }
        callback();
      }
    };
    return {
      accountMsg: {
        // accountBalance: 0, // 账号余额
        // pendWithdrawal: 0, // 待提现
        // cashWithdrawal: 0, // 已提现
        // canWithdrawal: 0, //可提现
      },
      disabled: false,
      data: {},
      form: {
        withdrawal: 1,
      },
      rule: {
        withdrawal: [{ validator: validateWithdrawal, trigger: "blur" }],
      },
    };
  },
  computed: {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let params = {};
      financeInfo(params)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            let data = res.data.data;
            let accountMsgData = data.account_balance_data;
            let accountMsg = accountMsgData.data;
            // 账号余额
            const accountBalance = accountMsg.account_balance;
            // 待提现
            const pendWithdrawal =
              accountMsg.cash_out_data.data.cash_out_waiting;
            // 已提现
            const cashWithdrawal = accountMsg.cash_out_data.data.cash_out;
            // 可提现
            const canWithdrawal = accountBalance - pendWithdrawal;

            this.accountMsg = {
              accountBalance: accountBalance, // 账号余额
              pendWithdrawal: pendWithdrawal, // 待提现
              cashWithdrawal: cashWithdrawal, // 已提现
              canWithdrawal: canWithdrawal, //可提现
            };
            // 代理开户信息
            this.data = data.account_info_data.data;
          } else {
            this.$Message.error({
              duration: 3,
              background: true,
              content: res.data.msg,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$Message.error({
            duration: 3,
            background: true,
            content: "获取失败!",
          });
        });
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        console.log(valid);
        if (valid) {
          this.disabled = false;
          let params = {
            money: this.form.withdrawal,
          };
          console.log(params, "params");
          applyCashout(params)
            .then((res) => {
              console.log(res);
              if (res.data.code == 0) {
                this.$Message.success({
                  duration: 3,
                  background: true,
                  content: res.data.msg || "提交成功！",
                });
                this.getData();
                this.$refs[name].resetFields();
              } else {
                this.$Message.error({
                  duration: 3,
                  background: true,
                  content: res.data.msg,
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.$Message.error({
                duration: 3,
                background: true,
                content: "提交失败！",
              });
            });
        } else {
          this.disabled = true;
          // this.$Message.error({
          // 	content: '表单内容不正确,请检查表单内容！',
          // 	duration: 5
          // });
        }
      });
    },
    allWithdrawal(name) {
      // 全部提现
      this.form.withdrawal = this.accountMsg.canWithdrawal;
      this.$refs[name].validate((valid) => {});
    },
    showBigImg(title, src) {
      if (src) {
        window.open(src);
      }

      console.log(src);
    },
  },
};
</script>

<style lang="less" scoped>
.app-list {
  flex: 1;
  margin-top: 30px;
  height: max-content;
  .content {
    // padding: 50px;
    padding: 20px;
    background-color: #fff;
    border-radius: 3px;
    // box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
    .form {
      width: 350px;
    }
  }
}
.bankImg {
  width: 300px;
  height: auto;
  // height: 300px;
}
.page-main {
  width: 90%;
  margin: 0 auto;
  padding-top: 10px;
  .box {
    margin-bottom: 30px;
    background-color: #ffffff;
    border-radius: 3px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
    padding: 25px;
  }
  .details {
    ul {
      padding: 30px;
      display: flex;
      justify-content: space-around;
    }

    li {
      flex: 1;
      text-align: center;
      .name {
        color: #9a9a9a;
        .ivu-icon {
          font-size: 26px;
          margin-right: 6px;
          vertical-align: middle;
        }
      }

      .number {
        font-size: 36px;
        font-weight: 600;
        color: #f47d01;
        margin: 30px auto;
      }
    }
  }
}
</style>
